import Udesk from 'Udesk';
import React, { FC, memo, useMemo } from 'react';
import NestHome from 'Component/common/nest-home-with-subnav';
import { getCurrentRouteName } from 'Udesk/system/subApp';
import UdeskLocales from 'UdeskLocales';

interface TemplateProps {
    match?: any;
}

const Template: FC<TemplateProps> = memo((props) => {
    const navLists = useMemo(
        () => [
            {
                text: /* 自动触发消息 */UdeskLocales['current'].pages.conversationAnalysis.planManage.index.autoTriggerMessage,
                pathName: getCurrentRouteName('automaticTriggerMessage'),
                isActive: (match, location) => {
                    return location.pathname.includes('/automatic-trigger-message');
                },
            },
        ],
        []
    );

    return <NestHome {...props} navLists={navLists} menuTitle={/* 计划管理 */UdeskLocales['current'].pages.conversationAnalysis.planManage.index.planManagement} />;
});

class TemplateClass extends React.Component {
    render(): React.ReactNode {
        return <Template {...this.props} />;
    }
}

export default Udesk.react.udeskify(TemplateClass);
